import { Route, Switch, useRouteMatch } from "react-router-dom";
import GenomicsResearchDash from "../Genomics/Research";
import GenomicsReHome from "./pages/Home/home";
import GenomicsProjects from "./tables/projectTable";
import GenomicsReSamples from "./tables/SampleAccessioning/index";
import GenomicsReSampleRegister from "./tables/SampleAccessioning/sampleAccessioningOnboarding";
// import GenomicsReCreateClient from "../GenomicsResearch-Panel/components/Bookings/clientCreate";
import Genfilter from "./pages/filter";
import './pages/filter.sass';
import GenomicsReClientInstitutetable from "./tables/ClientInstituteData/index";
import GenlabDealer from "./tables/Dealer/index";
import GenResearchfailedSamples from "./tables/FailedSamples/failedSamplesData";
import GenLabFailSamples from "./tables/FailedSamples/failedSamplesOnboarding";
import GenLabInstitueCreate from "./tables/InstituteCreation/index";
import GenlabEditProjects from "./tables/ProjectOnBoarding/editProjects";
import genomicsReCreateProjects from "./tables/ProjectOnBoarding/onboardingProjects";
import GenlabReProjectsTable from "./tables/projectTable";
import GenSamaadhanDeck from "./tables/samaadhanDeck/index";
import GenlabCreateTicket from "./tables/samaadhanDeck/createTicket";
import GenLabSampleTracker from "../GenomicsResearch-Panel/pages/sampleTracker/welcomePage";
import GenLabSampleTrackerCount from "../GenomicsResearch-Panel/pages/sampleTracker/index";
import GenlabSampleCount from "../GenomicsResearch-Panel/pages/sampleTracker/sampleCount";
import GenLabSampleReport from "../GenomicsResearch-Panel/pages/sampleTracker/sampleReport";
import GenLabSharing from "../GenomicsResearch-Panel/pages/sampleTracker/dataSharing";
import GenLabGenomIt from "../GenomicsResearch-Panel/pages/GenomIT/index";
import GenlabGenomSampleCount from "../GenomicsResearch-Panel/pages/GenomIT/sampleCount";
import GenLabGenomSampleReport from "../GenomicsResearch-Panel/pages/GenomIT/sampleReport";
import GenLabGenomSharing from "../GenomicsResearch-Panel/pages/GenomIT/dataSharing";

function GenomicsResearchAcessioningRoutes(props) {
    let { path } = useRouteMatch();
    return (
        <Switch>
            <GenomicsResearchDash>
                <Route
                    exact
                    path={`${path}`}
                    component={GenomicsReHome}
                />
                <Route
                    exact
                    path={`${path}/sampleregister`}
                    component={GenomicsReSampleRegister}
                />
                <Route
                    exact
                    path={`${path}/samples`}
                    component={GenomicsReSamples}
                />
                <Route
                    exact
                    path={`${path}/projects`}
                    component={GenomicsProjects}
                />
                <Route
                    exact
                    path={`${path}/createprojects/:id`}
                    component={genomicsReCreateProjects}
                />
                <Route
                    exact
                    path={`${path}/failedSamples/:id`}
                    component={GenLabFailSamples}
                />
                <Route
                    exact
                    path={`${path}/Client`}
                    component={GenomicsReClientInstitutetable}
                />
                <Route
                    exact
                    path={`${path}/institute/create`}
                    component={GenLabInstitueCreate}
                />
                <Route
                    exact
                    path={`${path}/projects/data/`}
                    component={GenlabReProjectsTable}
                />
                <Route
                    exact
                    path={`${path}/failedSamples`}
                    component={GenResearchfailedSamples}
                />
                <Route
                    exact
                    path={`${path}/dealer/create`}
                    component={GenlabDealer}
                />
                <Route
                    exact
                    path={`${path}/project-edit/:id/edit`}
                    component={GenlabEditProjects}
                />
                <Route
                    exact
                    path={`${path}/browseData`}
                    component={Genfilter}
                />
                <Route
                    exact
                    path={`${path}/samaadhan_itrack`}
                    component={GenSamaadhanDeck}
                />
                <Route
                    exact
                    path={`${path}/createTicket/:id`}
                    component={GenlabCreateTicket}
                />
                <Route
                    exact
                    path={`${path}/samples_tracker`}
                    component={GenLabSampleTracker}
                />
                <Route
                    exact
                    path={`${path}/samples_tracker_count`}
                    component={GenLabSampleTrackerCount}
                />
                
                <Route
                    exact
                    path={`${path}/genom_itr`}
                    component={GenLabGenomIt}
                />
                <Route
                    exact
                    path={`${path}/samples_count`}
                    component={GenlabSampleCount}
                />
                 <Route
                    exact
                    path={`${path}/genom_samples_count`}
                    component={GenlabGenomSampleCount}
                />
                <Route
                    exact
                    path={`${path}/samples_report`}
                    component={GenLabSampleReport}
                />
                <Route
                    exact
                    path={`${path}/genom_samples_report`}
                    component={GenLabGenomSampleReport}
                />
                <Route
                    exact
                    path={`${path}/data_share/:id`}
                    component={GenLabSharing}
                />
                 <Route
                    exact
                    path={`${path}/genom_data_share`}
                    component={GenLabGenomSharing}
                />
            </GenomicsResearchDash>
        </Switch>
    )
}

export default GenomicsResearchAcessioningRoutes;